import type { BriefingConfig } from "../_shared/types";

/**
 * Bindings that turn the shared briefing engine into *this* questionnaire.
 *
 * `company` maps to `projekt`, not to a company field: this briefing is filled
 * in once per report inside an already-scoped project, so the project name is
 * what identifies the file — and what the import mismatch check should compare.
 *
 * `id` and `storageKey` are contracts, not labels: `id` gates re-import of a
 * previously exported file, and changing `storageKey` orphans every draft
 * currently sitting in a client's browser.
 */
export const DASHBOARD_BRIEFING_CONFIG: BriefingConfig = {
  id: "power-bi-dashboard-briefing",
  filenamePrefix: "dbi-dashboard-briefing",
  storageKey: "dbi-dashboard-briefing-draft-v1",
  metaMap: {
    company: "projekt",
    reportName: "bericht",
    // No separate contact-name question: the trimmed catalog asks only for a
    // reply address, so the name would be a field with nothing depending on it.
    contactName: "",
    contactEmail: "kontaktmail",
  },
  // Shares the design briefing's route: same Slack webhook, same consent model.
  // The payload's `briefing` field tells the two apart downstream.
  sendEndpoint: "/api/design-briefing",
  foreignFileError: "Diese Datei stammt nicht aus diesem Dashboard-Briefing.",
  plainTextTitle: "Power BI Dashboard-Briefing",
};
